export default __webpack_public_path__ + "static/logo-n-3-c2ce7acf178e71ff80cbff44213c5a0c.svg";